import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

interface PDFGeneratorNodeData {
  label: string;
  title?: string;
  filename?: string;
}

const PDFGeneratorNode: React.FC<NodeProps<PDFGeneratorNodeData>> = ({ data = { label: 'PDF Generator' } }) => {
  return (
    <Box
      sx={{
        width: 140,
        height: 40,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #F59E0B',
        px: 1,
        outline: 'none',
        '&:focus': {
          outline: 'none',
        },
        '&:hover': {
          outline: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: 18,
          height: 18,
          backgroundColor: '#F59E0B',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1,
        }}
      >
        <PictureAsPdfIcon sx={{ color: '#ffffff', fontSize: 10 }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '9px', lineHeight: 1.2, color: '#1F2937' }}>
          {data.label}
        </Typography>
        {data.filename && (
          <Typography variant="caption" sx={{ fontSize: '7px', color: '#6B7280' }}>
            {data.filename}
          </Typography>
        )}
      </Box>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#000000', width: 5, height: 5 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#000000', width: 5, height: 5 }}
      />
    </Box>
  );
};

export default PDFGeneratorNode;

